import "../common/scroll-lock";
import toggleLock from "./scroll-lock";
import {WPApi} from "./wp-api";
import {isMobile, onClickOutside} from './utils';
import * as lottie from "lottie-web";


const api = new WPApi();
const iOSDownloadAppLink = "https://apps.apple.com/il/app/sport1-%D7%A1%D7%A4%D7%95%D7%A8%D7%981/id589009096";


jQuery(document).ready(($) => {
    const animationData = require(`../../animations/snake.json`);
    const $hamburger = $('.menu-item-logo-hamburger');
    let fantasyLeagueTriggerPopupLink = $('#fantasy-league-modal');
    const isIOSDevice = !window.MSStream && /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (fantasyLeagueTriggerPopupLink.length > 0) {
        fantasyLeagueTriggerPopupLink.attr('data-toggle', 'modal');
        fantasyLeagueTriggerPopupLink.attr('data-target', '#fantasy-league-modal');
        if (isIOSDevice) {
            $('#fantasy-league-modal #start')[0].href = iOSDownloadAppLink;
        }
    }

    let animatedLink = $('#primary-menu li.animated-link').get(0);
    let greenBallAnim = lottie.default.loadAnimation({
        container: animatedLink, // Required
        animationData, // Required
        renderer: 'svg', // Required
        loop: true, // Optional
        autoplay: true, // Optional
        name: 'snake',
    });

    $(animatedLink).data('animation', greenBallAnim);

    $('#sub-menu .menu-item-has-children > a').on('click', function (e) {
        if (window.outerWidth < 1260) {
            e.preventDefault();
            $(this).toggleClass('open');
            $(this).next('ul').toggleClass('open');
        }
    });

    $hamburger.on('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        $('.hamburger', $hamburger).toggleClass('is-active');
        toggleSubMenu();
    });

    $('#primary-menu .menu-item:not(.menu-item-logo) a').on('click', function () {
        let $this = $(this);
        let label = $this.text();
        sport1Analytics.sendEvent('header', 'header-strip-click', label);
    });

    $('#primary-menu .menu-item.menu-item-logo a, #site-navigation .logo a').on('click', function () {
        let $this = $(this);
        let label = $('img', $this).attr('alt');
        sport1Analytics.sendEvent('header', 'header-strip-click', label);
    });

    $('#masthead .main-sub-menu .menu-item a').on('click', function () {
        let $this = $(this);
        let label = $('img', $this).attr('alt');
        sport1Analytics.sendEvent('header', 'subheader-strip-click', label);
    });

    /**
     * Search form toggle
     * */
    $('#search svg, #search .close').on('click', function (e) {
        e.preventDefault();
        toggleSearch();
    });

    function toggleSearch() {

        let $search = $('#search');

        if ($search.hasClass('active')) {
            closeSearch();
        } else {
            openSearch();
        }

    }

    function openSearch() {
        let $body = $('body');
        $body.append(`
            <div class="search-backdrop backdrop position-fixed"></div>
        `);

        let $search = $('#search');

        $search.addClass('active');

        let searchForm = $('#search .search-form').detach();
        let searchResults = $('#search .search-results').detach();

        let backdrop = $('.search-backdrop');
        backdrop.append(searchForm).append(searchResults);

        let $searchForm = $('.search-backdrop .search-form');

        $searchForm.addClass('active');


        setSearchComponentsPosition();

        backdrop.addClass('active');
        toggleLock(true, backdrop);
        onClickOutside('#search,#search svg, .search-form,.search-results', function () {

            let isSearchOpen = $('#search').hasClass('active');
            if (isSearchOpen) {
                closeSearch();
            }

            return isSearchOpen;
        });

    }

    function closeSearch() {
        let backdrop = $('.search-backdrop');
        let $search = $('#search');
        let $searchForm = $('.search-backdrop .search-form');
        let $searchResults = $('.search-results', backdrop).detach().removeClass('has-results');

        if (isMobile()) {
            $.when($('.mobile-search .search-results').fadeOut()).then(() => {
                $('#masthead .main-sub-menu ul').fadeIn();
            });
        }

        $searchForm.removeClass('active');
        backdrop.removeClass('active')

        setTimeout(function () {
            $search.removeClass('active');
            $searchForm.detach().appendTo($search);
            $searchResults.appendTo($search);
            $searchForm.removeAttr('style');
            $searchResults.removeAttr('style');
            backdrop.detach();
            toggleLock(false, backdrop);
            $('.search-form input').val('');
        }, 300);
    }

    $('body').on('keyup', function (e) {
        if (e.keyCode === 27) {
            if ($('#search').hasClass('active')) {
                closeSearch();
            }
        }
    });

    $(window).on('resize', function (e) {
        if ($('#search').hasClass('active')) {
            setSearchComponentsPosition();
        }
    });

    function setSearchComponentsPosition() {
        if (isMobile()) {
            return;
        }
        let $searchForm = $('.search-backdrop .search-form');
        let $search = $('#search');

        /**
         * Search result top position in header height + search form height.
         * Left position is header search button left offset
         * */
        const $header = $('#masthead .header-menu-wrapper');
        let headerHeight = $header.outerHeight();
        const headerTop = $header.offset().top;
        const searchFormHeight = $searchForm.height();

        const $topAdWrapper = $('.top-ad-wrapper');
        let adWrapperHeight = 0;
        if ($topAdWrapper.length) {
            adWrapperHeight = $topAdWrapper.height();
        }

        const topAdTop = $topAdWrapper.get(0).getBoundingClientRect().top;

        // top add still visible
        if (headerTop <= adWrapperHeight) {
            headerHeight += adWrapperHeight + topAdTop;
        }

        $searchForm.css({
            left: $search.offset().left + 'px',
            top: headerHeight + 'px'
        });


        $('.search-backdrop .search-results').css({
            left: $search.offset().left + 'px',
            top: headerHeight + searchFormHeight + 'px'
        });
    }

    let lastSearchQuery = '';

    /**
     * Search
     * */
    $('.search-form input').on('keyup', debounce(async function () {
        let s = $(this).val();

        if (s && s.length && s !== lastSearchQuery) {
            lastSearchQuery = s;
            let results = await api.get(`sport1/v1/search/?s=${s}&html=true`);

            let searchFormContainer = '.search-backdrop';
            if (isMobile()) {
                searchFormContainer = '.mobile-search';
                $.when($('#masthead .main-sub-menu ul').fadeOut()).then(() => {
                    $(`${searchFormContainer} .search-results`).fadeIn();
                });
            }

            $(`${searchFormContainer} .search-results .search-results-section.teams-and-leagues .results`).html(results.teams_and_leagues);
            $(`${searchFormContainer} .search-results .search-results-section.posts .results`).html(results.posts);

            $(`${searchFormContainer} .search-results`).addClass('has-results');
            if (isMobile()) {
                $('.search-results article .article-card-title').each(function () {
                    $clamp(this, {truncationChar: '...', clamp: 3, useNativeClamp: false});
                });
            }
            lazyLoader.update();
        }

    }, 300));

    function debounce(func, wait, immediate) {
        let timeout;
        return function () {
            let context = this, args = arguments;
            let later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            let callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    function toggleSubMenu() {

        const $subMenu = $('#sub-menu');

        const isOpen = $subMenu.hasClass('open');

        if (window.outerWidth < 1260) {
            toggleLock(!isOpen, $subMenu);
        }

        if (isOpen && isMobile()) {
            closeSearch();
        }

        $('.header-menu-wrapper').toggleClass('open');

        $subMenu.toggleClass('open');
    }
});
